export default __webpack_public_path__ + "static/media/publish.2dd25173.svg";